import React from "react";

const StatementOfBeliefs = () => {
    const beliefs = [
        {
            id: 1,
            text: "All American citizens have God-given unalienable rights; among these are life, liberty, and the pursuit of happiness; no governmental entity can revoke these rights.",
        },
        {
            id: 2,
            text: "The government has no power except that which is given to it by American citizens.",
        },
        {
            id: 3,
            text: "Elected officials have the duty to protect and defend the freedom and liberty guaranteed by America's founding documents, including private property rights.",
        },
        {
            id: 4,
            text: "Accountability of elected officials is best achieved by citizens in their local communities",
        },
        {
            id: 5,
            text: "For American society to prosper, it must function according to the principles of freedom, liberty, and limited government.",
        }
    ];

    return (
        <div className="w-full px-20px max-w-[1336px] mx-auto lg-xl:mt-20 lg:mt-15 mt-10">
            <div className="lg:mb-10 mb-5">
                <h2 className="font-bold text-center lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-customRed tracking-normal uppercase font-fira pb-2.5">
                    statement of beliefs
                </h2>

                <p className="text-center lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal">
                    "A democratic society depends upon an informed and educated citizenry." Thomas Jefferson
                </p>
            </div>

           <div className="flex items-stretch gap-[24px] flex-wrap justify-center">
                {beliefs.map((belief) => (
                    <div
                        key={belief.id}
                        className={`border border-[#E2E2E0] rounded-[12px] p-20px flex items-start xxl:w-[32.099%] xxl:max-w-[32.099%] lg:w-[48%] lg:max-w-[48%] w-full max-w-full h-auto max-w-full relative shadow-[0px_90px_160px_0px_rgba(0,0,0,0.06)] bg-white`}
                    >
                        <div className="mr-[18px]">
                            <div className="bg-red-600 text-white rounded-full w-[25px] h-[25px] flex items-center justify-center lg:mt-2 mt-1">
                                <img src="/star.svg" alt="star" />
                            </div>
                        </div>
                        <p className="lg:text-22px lg:leading-[35.2px] text-18px leading-[24px] tracking-normal font-fira font-normal">
                            {belief.text}
                        </p>
                    </div>
                ))}
        </div>

        </div>
    );
};

export default StatementOfBeliefs;